var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('section', {
    staticClass: "sub-visual"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap mb-24 mb-md-50 mb-lg-0"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl"
  }, [_vm._v(" Business ")])], 1)]), _c('v-img', {
    staticClass: "sub-visual__img",
    attrs: {
      "src": "/images/sub/business/sub-visual-business.jpg"
    }
  }), _c('sub-tab', {
    attrs: {
      "page": "비즈니스",
      "tabActive": 1
    }
  })], 1), _c('section', {
    staticClass: "sub-section sub-section--overview pb-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap tit-wrap--center",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('h3', {
    staticClass: "tit tit--lg mb-12"
  }, [_vm._v(" ONE STOP SHOPPING ")]), _c('p', {
    staticClass: "page-text page-text--lg font-weight-medium"
  }, [_vm._v(" 소상 공인부터 프랜차이즈 그리고 대기업 사장님들까지 다양한 수효를 아우르는 모두 에프엔티의 서비스 ")])]), _c('v-card', {
    staticClass: "business-info white--text",
    attrs: {
      "flat": "",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "px-20 py-50 py-md-74 pa-lg-100"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 d-flex flex-wrap align-content-space-between"
  }, [_c('div', {
    staticClass: "w-100 mb-12 mb-md-0"
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/business/overview/logo.png",
      "max-width": "80"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit font-pretendard"
  }, [_vm._v(" (주) 모두에프엔티 ")])]), _c('p', {
    staticClass: "page-text page-text font-weight-medium"
  }, [_vm._v(" 여러가지 식자재 재료가 한번에 필요하고 물류가 고민일때 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 모두 에프엔티가 유통에 도움을 드립니다. ")])])])]), _c('v-col', {
    staticClass: "line-height-11",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_c('span', {
    staticClass: "d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0"
  }, [_vm._v("연매출")]), _vm._v(" 89억 5000만원 ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_c('span', {
    staticClass: "d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0"
  }, [_vm._v("자본금")]), _vm._v(" 1억 5000만원 ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_c('span', {
    staticClass: "d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0"
  }, [_vm._v("업종")]), _vm._v(" 식자재,유통,도소매업,음식료품 취급 ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_c('span', {
    staticClass: "d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0"
  }, [_vm._v("주소")]), _vm._v(" 경기도 하남시 창우로 38-35번지 ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_c('span', {
    staticClass: "d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0"
  }, [_vm._v("직원수")]), _vm._v(" 18명 ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_c('span', {
    staticClass: "d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0"
  }, [_vm._v("사업자 번호")]), _vm._v(" 126-81-93789 ")])])], 1)], 1)], 1)], 1)]), _c('div', {
    staticClass: "my-80 my-md-120 my-lg-160"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--center"
  }, [_c('h3', {
    staticClass: "tit tit--lg",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("조직도")])]), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/sub/business/overview/organization-mobile.jpg",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _c('v-img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "src": "/images/sub/business/overview/organization.png",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  })], 1)], 1), _c('div', {
    staticClass: "ci"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap tit-wrap--center white--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('h3', {
    staticClass: "tit tit--lg"
  }, [_vm._v("CI")])]), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/sub/business/overview/ci-mobile.png",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _c('v-img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "src": "/images/sub/business/overview/ci.png",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _c('div', {
    staticClass: "pt-30 pt-md-44 pt-lg-60",
    attrs: {
      "align": "center"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "w-140px w-md-160px",
    attrs: {
      "large": "",
      "href": "/assets/logo/logo.ai"
    }
  }, [_vm._v("AI 다운로드")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "w-140px w-md-160px",
    attrs: {
      "large": "",
      "href": "/assets/logo/logo.png",
      "target": "_blank"
    }
  }, [_vm._v("PNG 다운로드")])], 1)], 1)], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }